/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: =, Brian Bal, bohdev
 */
import React, { Component } from "react"
import { connect } from "react-redux"
import { ActionBar } from "./ActionBar.js"
import { Element } from "trux"
import * as stat from "../../util/analytics"
import * as act from "./actions"

import "./Page.css"

class PageComponent extends Component {
    constructor(props) {
        super(props)

        this.state = {
            menuOpen: null,
            showMore: false,
            showTeams: null,
        }

        this.toggleMenu = this.toggleMenu.bind(this)
        this.toggleMore = this.toggleMore.bind(this)
        this.toggleTeams = this.toggleTeams.bind(this)
        this.onMenuItemClicked = this.onMenuItemClicked.bind(this)
        this.onTeamItemClicked = this.onTeamItemClicked.bind(this)
        this.onLogoutPressed = this.onLogoutPressed.bind(this)
    }

    toggleTeams(e) {
        stat.statEvent("main-nav", "team-picker-toggle", "pressed")
        if (e) {
            e.preventDefault()
        }
        var show = this.state.showTeams
        if (show) {
            show = false
        } else {
            show = true
        }
        this.setState({ showTeams: show })
    }

    toggleMore(e) {
        stat.statEvent("main-nav", "more", "pressed")
        if (e) {
            e.preventDefault()
        }
        this.setState({ showMore: !this.state.showMore })
    }

    toggleMenu() {
        stat.statEvent("main-nav", "toggle-menu", "pressed")
        var show = this.state.menuOpen
        if (show) {
            show = false
        } else {
            show = true
        }
        this.setState({ menuOpen: show })
    }

    onMenuItemClicked(e) {
        this.toggleMenu()
    }

    onTeamItemClicked(e) {
        stat.statEvent("main-nav", "team-row", "pressed")
        this.toggleTeams()
    }

    onLogoutPressed(e) {
        stat.statEvent("main-nav", "logout", "pressed")
        if (e) {
            e.preventDefault()
        }
        this.props.logout()
        this.toggleMenu()
    }

    showAdminMenu() {
        if (
            this.getDivisionId() <= 0 ||
            !this.props.isTeamLoggedIn ||
            !this.props.user
        ) {
            return false
        }
        return true
    }

    getDivisionId() {
        let divisionId = 0
        if (this.props.divisions && this.props.divisions.length > 0) {
            divisionId = this.props.divisions[0].division_id
            if (this.props.currentTeam) {
                for (var d in this.props.divisions) {
                    var div = this.props.divisions[d]
                    for (var t in div.myTeams) {
                        var tm = div.myTeams[t]
                        if (tm.team_id === this.props.currentTeam.team_id) {
                            divisionId = div.division_id
                            break
                        }
                    }
                }
            }
        }
        return divisionId
    }

    render() {
        return (
            <Element className="Page">
                <ActionBar
                    user={this.props.user}
                    team={this.props.currentTeam}
                    // eslint-disable-next-line eqeqeq
                    showTeamPicker={this.props.user != null}
                    onMenuClicked={this.toggleMenu}
                    onChooseTeamClicked={this.toggleTeams}
                    isGameResults={this.props.isGameResults}
                />
                <section
                    className={`trc-page-content ${
                        this.props.noPadding ? " no-padding" : ""
                    }`}
                >
                    {this.props.children}
                </section>
            </Element>
        )
    }

    clubItems() {
        let k = 0
        return this.props.divisions.map((club) => {
            k++
            return (
                <li key={`teampicker-club-${k}`}>
                    <h3 className="team-section-title">{club.title}</h3>
                    <ul className="team-list">
                        {this.teamItems(club.myTeams)}
                    </ul>
                </li>
            )
        })
    }

    teamItems(teams) {
        let n = 0
        return teams.map((t) => {
            var className = ""
            if (t.name === this.props.teamId) {
                className = "current"
            }
            n++
            return (
                <li className={className} key={`teampicker-team-${n}`}>
                    <a onClick={this.onTeamItemClicked} href={`/#/${t.name}`}>
                        {t.title}
                    </a>
                </li>
            )
        })
    }
}

const mapStateToProps = (state) => {
    let backTeam = null
    if (state.divisions.value && state.divisions.value.length > 0) {
        var div = state.divisions.value[0]
        if (div.myTeams.length > 0) {
            backTeam = div.myTeams[0]
        }
    }

    return {
        isTeamLoggedIn: state.isTeamLoggedIn,
        divisions: state.divisions.value ? state.divisions.value : [],
        currentTeam: state.team.value,
        user: state.user.value,
        backTeam: backTeam,
        acl: state.acl.value ? state.acl.value : {},
        rev: new Date().getTime(),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => {
            dispatch(act.logoutUser())
        },
    }
}

export const Page = connect(mapStateToProps, mapDispatchToProps)(PageComponent)
